import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { API_URL } from "../../Constants";
import ivrAd from "../../assets/ivrad.jpeg";
import lmsAd from "../../assets/lmsad.jpeg";

const ICE_SERVERS = [{ urls: 'stun:stun.l.google.com:19302' }];
const WS_BASE = API_URL.replace(/^http/, 'ws');
const MAX_RECONNECT_ATTEMPTS = 5;

const AD_SLIDES = [
  {
    id: 'ivr',
    src: ivrAd,
    alt: 'IVR GURU bulk voice calls and auto dialer',
    href: 'https://www.ivrguru.com',
    name: 'IVR GURU',
    tagline: 'Bulk voice calls & auto dialer',
    host: 'ivrguru.com',
  },
  {
    id: 'lms',
    src: lmsAd,
    alt: 'LMS lead management system',
    href: 'https://lmsbots.com',
    name: 'LMS Bots',
    tagline: 'Lead management system',
    host: 'lmsbots.com',
  },
];
const AD_INTERVAL_MS = 5000;

// --- SVG Icons Helper Components ---
const MicOnIcon = ({ width = 20, height = 20, className = "" }) => (
  <svg width={width} height={height} className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3z"></path>
    <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
    <line x1="12" y1="19" x2="12" y2="23"></line>
    <line x1="8" y1="23" x2="16" y2="23"></line>
  </svg>
);
const MicOffIcon = ({ width = 20, height = 20, className = "" }) => (
  <svg width={width} height={height} className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="1" y1="1" x2="23" y2="23"></line>
    <path d="M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6"></path>
    <path d="M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23"></path>
    <line x1="12" y1="19" x2="12" y2="23"></line>
    <line x1="8" y1="23" x2="16" y2="23"></line>
  </svg>
);
const CamOnIcon = ({ width = 20, height = 20, className = "" }) => (
  <svg width={width} height={height} className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="23 7 16 12 23 17 23 7"></polygon>
    <rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect>
  </svg>
);
const CamOffIcon = ({ width = 20, height = 20, className = "" }) => (
  <svg width={width} height={height} className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 16v1a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2m5.66 0H14a2 2 0 0 1 2 2v3.34l1 1L23 7v10"></path>
    <line x1="1" y1="1" x2="23" y2="23"></line>
  </svg>
);
const ScreenIcon = ({ width = 20, height = 20, className = "" }) => (
  <svg width={width} height={height} className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
    <line x1="8" y1="21" x2="16" y2="21"></line>
    <line x1="12" y1="17" x2="12" y2="21"></line>
  </svg>
);
const XIcon = ({ width = 22, height = 22, className = "" }) => (
  <svg width={width} height={height} className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
);
const EyeIcon = ({ width = 16, height = 16, className = "" }) => (
  <svg width={width} height={height} className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z"></path>
    <circle cx="12" cy="12" r="3"></circle>
  </svg>
);
const EyeOffIcon = ({ width = 16, height = 16, className = "" }) => (
  <svg width={width} height={height} className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17.94 17.94A10.94 10.94 0 0 1 12 19c-7 0-11-7-11-7a18.6 18.6 0 0 1 5.06-5.94M9.9 4.24A10.94 10.94 0 0 1 12 4c7 0 11 7 11 7a18.6 18.6 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
    <line x1="1" y1="1" x2="23" y2="23"></line>
  </svg>
);
const AlertIcon = ({ width = 26, height = 26, className = "" }) => (
  <svg width={width} height={height} className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
    <line x1="12" y1="9" x2="12" y2="13"></line>
    <line x1="12" y1="17" x2="12.01" y2="17"></line>
  </svg>
);
const LinkIcon = ({ width = 14, height = 14, className = "" }) => (
  <svg width={width} height={height} className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
  </svg>
);
const CheckIcon = ({ width = 14, height = 14, className = "" }) => (
  <svg width={width} height={height} className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12"></polyline>
  </svg>
);

// Shared keyframes / motion, scoped to this page. Respects reduced-motion.
const PageMotionStyles = () => (
  <style>{`
    @keyframes vcFadeUp { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
    @keyframes vcScaleIn { from { opacity: 0; transform: scale(.95); } to { opacity: 1; transform: scale(1); } }
    @keyframes vcPulse { 0%, 100% { opacity: 1; } 50% { opacity: .4; } }
    @keyframes vcRing { 0% { transform: scale(.9); opacity: .8; } 100% { transform: scale(1.25); opacity: 0; } }
    .vc-in { animation: vcFadeUp .4s cubic-bezier(.16,1,.3,1) both; }
    .vc-in-scale { animation: vcScaleIn .35s cubic-bezier(.16,1,.3,1) both; }
    .vc-pulse { animation: vcPulse 1.8s ease-in-out infinite; }
    .vc-ring { animation: vcRing 2.2s ease-out infinite; }
    @media (prefers-reduced-motion: reduce) {
      .vc-in, .vc-in-scale, .vc-pulse, .vc-ring { animation: none; }
    }
  `}</style>
);

// Layered background: a soft signal-green glow plus a fine dot grid, evoking a
// broadcast/on-air feel without leaning on flat black or a stock gradient.
const PAGE_BG = {
  backgroundColor: '#08090d',
  backgroundImage:
    'radial-gradient(ellipse 900px 460px at 50% -8%, rgba(52,211,153,0.09), transparent 65%),' +
    'radial-gradient(circle, rgba(255,255,255,0.028) 1px, transparent 1px)',
  backgroundSize: 'auto, 24px 24px',
  backgroundPosition: 'center, center',
};

const ChevronLeftIcon = ({ width = 18, height = 18 }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="15 18 9 12 15 6"></polyline>
  </svg>
);
const ChevronRightIcon = ({ width = 18, height = 18 }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 18 15 12 9 6"></polyline>
  </svg>
);

const ArrowUpRightIcon = ({ width = 14, height = 14 }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="7" y1="17" x2="17" y2="7"></line>
    <polyline points="7 7 17 7 17 17"></polyline>
  </svg>
);

function AdCarousel() {
  const [slides, setSlides] = useState(AD_SLIDES);
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const touchStartX = useRef(null);
  const didSwipe = useRef(false);

  const count = slides.length;

  const go = useCallback((next) => {
    setIndex((i) => (count ? (((typeof next === 'function' ? next(i) : next) % count) + count) % count : 0));
  }, [count]);

  useEffect(() => {
    if (paused || count < 2) return undefined;
    const id = setInterval(() => go((i) => i + 1), AD_INTERVAL_MS);
    return () => clearInterval(id);
  }, [paused, count, go]);

  const handleImageError = (id) => {
    setSlides((prev) => prev.filter((s) => s.id !== id));
    setIndex(0);
  };

  const onTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
    didSwipe.current = false;
  };
  const onTouchEnd = (e) => {
    if (touchStartX.current === null) return;
    const dx = e.changedTouches[0].clientX - touchStartX.current;
    touchStartX.current = null;
    if (Math.abs(dx) > 40) {
      didSwipe.current = true;
      go((i) => i + (dx < 0 ? 1 : -1));
    }
  };
  // A swipe should change the slide, not open the link.
  const onSlideClick = (e) => {
    if (didSwipe.current) {
      e.preventDefault();
      didSwipe.current = false;
    }
  };

  if (!count) return null;

  const current = slides[index] || slides[0];

  return (
    <aside
      className="hidden lg:flex flex-col gap-3.5 w-[400px] xl:w-[480px] shrink-0 vc-in"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      aria-label="Our services"
    >
      <div className="flex items-center justify-between px-1">
        <span className="text-[11px] uppercase tracking-[0.14em] text-[#6b6f7b] font-medium">Our services</span>
        <span className="text-[11px] text-[#6b6f7b] tabular-nums">{index + 1} / {count}</span>
      </div>

      <div
        className="relative rounded-[22px] overflow-hidden border border-[#23252e] bg-[#0e0f14] shadow-[0_24px_70px_rgba(0,0,0,0.5)]"
        onTouchStart={onTouchStart}
        onTouchEnd={onTouchEnd}
      >
        <div
          className="flex transition-transform duration-500 ease-out"
          style={{ transform: `translateX(-${index * 100}%)` }}
        >
          {slides.map((slide, i) => (
            <div
              key={slide.id}
              className="group relative w-full shrink-0 aspect-[4/5] bg-white"
              style={{ maxHeight: 'calc(100vh - 260px)', minHeight: '360px' }}
              aria-hidden={i !== index}
            >
              <a
                href={slide.href}
                target="_blank"
                rel="noopener noreferrer"
                onClick={onSlideClick}
                tabIndex={i === index ? 0 : -1}
                title={`Visit ${slide.host}`}
                aria-label={`Visit ${slide.host} (opens in a new tab)`}
                className="block w-full h-full cursor-pointer"
              >
                <img
                  src={slide.src}
                  alt={slide.alt}
                  draggable={false}
                  onError={() => handleImageError(slide.id)}
                  className="w-full h-full object-contain select-none"
                />
                <span className="absolute inset-x-0 bottom-0 flex items-center justify-between gap-2 px-5 py-3.5 bg-gradient-to-t from-black/75 via-black/40 to-transparent text-white text-[13px] font-medium opacity-0 group-hover:opacity-100 group-focus-within:opacity-100 transition-opacity duration-300">
                  <span>Visit {slide.host}</span>
                  <ArrowUpRightIcon width={16} height={16} />
                </span>
              </a>
            </div>
          ))}
        </div>

        {count > 1 && (
          <>
            <button
              type="button"
              onClick={() => go((i) => i - 1)}
              className="absolute left-2.5 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-black/45 hover:bg-black/70 backdrop-blur-sm border border-white/10 text-white flex items-center justify-center transition-colors"
              title="Previous"
              aria-label="Previous slide"
            >
              <ChevronLeftIcon />
            </button>
            <button
              type="button"
              onClick={() => go((i) => i + 1)}
              className="absolute right-2.5 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-black/45 hover:bg-black/70 backdrop-blur-sm border border-white/10 text-white flex items-center justify-center transition-colors"
              title="Next"
              aria-label="Next slide"
            >
              <ChevronRightIcon />
            </button>
          </>
        )}
      </div>

      {/* Caption + call to action for the active slide */}
      <a
        href={current.href}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-between gap-3 px-4 py-3 rounded-2xl bg-[#121319] border border-[#23252e] hover:border-emerald-400/30 hover:bg-[#161720] transition-colors"
      >
        <span className="min-w-0">
          <span className="block text-[14px] font-semibold text-[#f1f2f5] truncate">{current.name}</span>
          <span className="block text-[12px] text-[#8a8f9c] truncate">{current.tagline}</span>
        </span>
        <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-emerald-400/10 border border-emerald-400/20 text-emerald-300 text-[12px] font-medium shrink-0">
          {current.host}
          <ArrowUpRightIcon width={13} height={13} />
        </span>
      </a>

      {count > 1 && (
        <div className="flex items-center justify-center gap-2">
          {slides.map((slide, i) => (
            <button
              key={slide.id}
              type="button"
              onClick={() => go(i)}
              title={`Show slide ${i + 1}`}
              aria-label={`Show slide ${i + 1}`}
              className={`h-1.5 rounded-full transition-all duration-300 ${i === index ? 'w-6 bg-emerald-400' : 'w-1.5 bg-white/20 hover:bg-white/40'}`}
            />
          ))}
        </div>
      )}
    </aside>
  );
}

// Layout: services carousel on the left, page content (login / join form) on the right.
const PageShell = ({ children }) => (
  <div className="min-h-screen flex items-center justify-center gap-8 xl:gap-14 p-6 text-[#f1f2f5] font-sans box-border" style={PAGE_BG}>
    <PageMotionStyles />
    <AdCarousel />
    <div
      className="hidden lg:block w-px self-stretch bg-gradient-to-b from-transparent via-[#23252e] to-transparent"
      aria-hidden="true"
    ></div>
    <div className="flex-1 min-w-0 flex items-center justify-center">{children}</div>
  </div>
);

const CenteredCard = ({ children, maxWidth = '380px' }) => (
  <PageShell>
    <div
      className="w-full bg-[#121319] border border-[#23252e] rounded-[22px] p-8 shadow-[0_24px_70px_rgba(0,0,0,0.5)] vc-in-scale"
      style={{ maxWidth }}
    >
      {children}
    </div>
  </PageShell>
);

// Helper for formatting duration
function formatDuration(ms) {
  if (!ms || ms < 0) return '00:00';
  const totalSec = Math.floor(ms / 1000);
  const m = Math.floor(totalSec / 60);
  const s = totalSec % 60;
  return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
}

function getOrCreateClientId() {
  const key = 'videoCallClientId';
  let id = sessionStorage.getItem(key);
  if (!id) {
    id = window.crypto && window.crypto.randomUUID
      ? window.crypto.randomUUID()
      : 'c-' + Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem(key, id);
  }
  return id;
}

function initials(name) {
  return name.trim().split(/\s+/).map((p) => p[0]).slice(0, 2).join('').toUpperCase() || '?';
}

function describeJoinFailure(event) {
  const reason = event && event.reason ? event.reason : '';
  if (reason === 'room_full') {
    return 'This meeting already has two participants.';
  }
  return 'Could not join this meeting.';
}

// Maps the free-text call status to a small semantic tone for the status dot.
// Purely presentational — does not affect connection logic.
function getStatusTone(status) {
  if (!status) return 'neutral';
  const s = status.toLowerCase();
  if (s.includes('connected')) return 'live';
  if (s.includes('issue') || s.includes('lost')) return 'danger';
  if (s.includes('reconnecting') || s.includes('connecting') || s.includes('waiting')) return 'pending';
  if (s.includes('left') || s.includes('ended')) return 'neutral';
  return 'neutral';
}

const TONE_DOT_CLASS = {
  live: 'bg-emerald-400 shadow-[0_0_8px_rgba(52,211,153,0.7)]',
  pending: 'bg-amber-400 shadow-[0_0_8px_rgba(251,191,36,0.6)] vc-pulse',
  danger: 'bg-red-500 shadow-[0_0_8px_rgba(239,68,68,0.6)] vc-pulse',
  neutral: 'bg-[#5c5f6b]',
};

// A circular control button. Purely presentational wrapper around onClick/isOn.
const ControlButton = ({ icon, isOn, label, onClick, disabled, title }) => {
  const circleClass = isOn
    ? 'bg-white/[0.07] border-white/[0.09] text-[#f1f2f5] hover:bg-white/[0.12]'
    : 'bg-red-500/10 border-red-500/30 text-red-400 hover:bg-red-500/20 shadow-[0_0_14px_rgba(239,68,68,0.15)]';
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      title={title}
      className="flex flex-col items-center gap-1.5 disabled:opacity-40 disabled:cursor-not-allowed"
    >
      <span className={`w-14 h-14 rounded-full border flex items-center justify-center transition-all duration-150 active:scale-90 ${circleClass}`}>
        {icon}
      </span>
      <span className="text-[11px] text-[#8a8f9c] font-medium">{label}</span>
    </button>
  );
};

export default function VideoCallPage() {
  const [searchParams] = useSearchParams();
  const roomId = searchParams.get('room');
  const initialTicket = searchParams.get('ticket') || '';

  const clientIdRef = useRef(getOrCreateClientId());

  const [phase, setPhase] = useState('loading');
  const phaseRef = useRef('loading');
  const setPhaseTracked = useCallback((next) => {
    phaseRef.current = next;
    setPhase(next);
  }, []);

  const [requiresPassword, setRequiresPassword] = useState(false);
  const [passwordInput, setPasswordInput] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [nameInput, setNameInput] = useState('');
  const [joinError, setJoinError] = useState('');

  const [callStatus, setCallStatus] = useState('Connecting...');
  const [hasLocalVideo, setHasLocalVideo] = useState(false);
  const [hasRemoteVideo, setHasRemoteVideo] = useState(false);
  const [showRemoteTile, setShowRemoteTile] = useState(false);
  const [remoteLabel, setRemoteLabel] = useState('Participant');
  const [localInitials, setLocalInitials] = useState('');
  const [remoteInitials, setRemoteInitials] = useState('?');
  const [micOn, setMicOn] = useState(false);
  const [camOn, setCamOn] = useState(false);
  const [screenOn, setScreenOn] = useState(false);

  // New UI states
  const [isFocused, setIsFocused] = useState(false);
  const [showLeaveConfirm, setShowLeaveConfirm] = useState(false);
  const [finalDuration, setFinalDuration] = useState('');
  const [linkCopied, setLinkCopied] = useState(false);
  const [elapsedLabel, setElapsedLabel] = useState('00:00');
  const callStartTimeRef = useRef(null);

  const localVideoRef = useRef(null);
  const remoteVideoRef = useRef(null);
  const remoteStreamRef = useRef(null);

  const wsRef = useRef(null);
  const pcRef = useRef(null);
  const localStreamRef = useRef(null);
  const screenStreamRef = useRef(null);
  const cameraTrackRef = useRef(null);
  const micTrackRef = useRef(null);
  const audioSenderRef = useRef(null);
  const videoSenderRef = useRef(null);

  const isHostRef = useRef(false);
  const politeRef = useRef(false);
  const makingOfferRef = useRef(false);
  const ignoreOfferRef = useRef(false);
  const displayNameRef = useRef('Guest');
  const activeTicketRef = useRef(initialTicket);
  const lastPasswordRef = useRef('');
  const intentionalLeaveRef = useRef(false);
  const reconnectAttemptsRef = useRef(0);
  const reconnectTimerRef = useRef(null);

  useEffect(() => {
    if (!roomId) {
      setJoinError('No room specified.');
      setPhaseTracked('error');
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(`${API_URL}/api/videocalls/${roomId}`);
        if (cancelled) return;
        if (!res.ok) {
          setJoinError('This meeting link is invalid or has expired.');
          setPhaseTracked('error');
          return;
        }
        const info = await res.json();
        if (cancelled) return;
        if (info.ended) {
          setJoinError('This meeting has already ended.');
          setPhaseTracked('error');
          return;
        }
        if (info.ticket) {
          activeTicketRef.current = info.ticket;
        }
        setRequiresPassword(!!info.requiresPassword);
        setPhaseTracked('preJoin');
      } catch (e) {
        if (!cancelled) {
          setJoinError('Network error. Please try again.');
          setPhaseTracked('error');
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [roomId, setPhaseTracked]);

  const ensureLocalStream = useCallback(() => {
    if (!localStreamRef.current) {
      localStreamRef.current = new MediaStream();
      if (localVideoRef.current) {
        localVideoRef.current.srcObject = localStreamRef.current;
      }
    }
    return localStreamRef.current;
  }, []);

  const refreshLocalTile = useCallback(() => {
    setHasLocalVideo(!!cameraTrackRef.current || !!screenStreamRef.current);
  }, []);

  const hideRemoteTile = useCallback(() => {
    setShowRemoteTile(false);
    setHasRemoteVideo(false);
    setIsFocused(false);
    remoteStreamRef.current = null;
    if (remoteVideoRef.current) {
      remoteVideoRef.current.srcObject = null;
    }
    setRemoteInitials('?');
    setRemoteLabel('Participant');
  }, []);

  const sendSignal = useCallback((data) => {
    const ws = wsRef.current;
    if (ws && ws.readyState === WebSocket.OPEN) {
      ws.send(JSON.stringify({ type: 'signal', data }));
    }
  }, []);

  const sendProfile = useCallback(() => {
    const ws = wsRef.current;
    if (ws && ws.readyState === WebSocket.OPEN) {
      ws.send(JSON.stringify({ type: 'profile', data: { name: displayNameRef.current } }));
    }
  }, []);

  const resetPeerConnection = useCallback(() => {
    if (pcRef.current) {
      pcRef.current.close();
      pcRef.current = null;
    }
    audioSenderRef.current = null;
    videoSenderRef.current = null;
    makingOfferRef.current = false;
    ignoreOfferRef.current = false;
  }, []);

  const startPeerConnection = useCallback(() => {
    if (pcRef.current) return;
    const pc = new RTCPeerConnection({ iceServers: ICE_SERVERS });
    pcRef.current = pc;
    makingOfferRef.current = false;
    ignoreOfferRef.current = false;

    pc.onicecandidate = (event) => {
      if (event.candidate) {
        sendSignal({ candidate: event.candidate });
      }
    };

    pc.ontrack = (event) => {
      const stream = event.streams && event.streams.length > 0
        ? event.streams[0]
        : new MediaStream([event.track]);

      remoteStreamRef.current = stream;

      if (remoteVideoRef.current) {
        remoteVideoRef.current.srcObject = stream;
      }

      setHasRemoteVideo(true);
      setShowRemoteTile(true);
    };

    pc.onnegotiationneeded = async () => {
      try {
        makingOfferRef.current = true;
        await pc.setLocalDescription();
        sendSignal({ sdp: pc.localDescription });
      } catch (err) {
        console.error('[VideoCall] negotiation error', err);
      } finally {
        makingOfferRef.current = false;
      }
    };

    pc.oniceconnectionstatechange = () => {
      if (pc.iceConnectionState === 'failed') {
        try { pc.restartIce(); } catch (e) {}
      }
    };

    pc.onconnectionstatechange = () => {
      if (pc.connectionState === 'connected') {
        setCallStatus('Connected');
      } else if (pc.connectionState === 'connecting') {
        setCallStatus('Connecting...');
      } else if (pc.connectionState === 'disconnected') {
        setCallStatus('Reconnecting...');
      } else if (pc.connectionState === 'failed') {
        setCallStatus('Connection issue — retrying...');
      }
    };

    audioSenderRef.current = null;
    videoSenderRef.current = null;
    const localStream = localStreamRef.current;
    if (localStream) {
      for (const track of localStream.getTracks()) {
        const sender = pc.addTrack(track, localStream);
        if (track.kind === 'audio') audioSenderRef.current = sender;
        if (track.kind === 'video') videoSenderRef.current = sender;
      }
    }
  }, [sendSignal]);

  const handleSignal = useCallback(async (data) => {
    if (!pcRef.current) {
      startPeerConnection();
    }
    const pc = pcRef.current;
    try {
      if (data.sdp) {
        const offerCollision = data.sdp.type === 'offer'
          && (makingOfferRef.current || pc.signalingState !== 'stable');
        ignoreOfferRef.current = !politeRef.current && offerCollision;
        if (ignoreOfferRef.current) {
          return;
        }
        await pc.setRemoteDescription(data.sdp);
        if (data.sdp.type === 'offer') {
          await pc.setLocalDescription();
          sendSignal({ sdp: pc.localDescription });
        }
      } else if (data.candidate) {
        try {
          await pc.addIceCandidate(data.candidate);
        } catch (err) {
          if (!ignoreOfferRef.current) {
            console.warn('[VideoCall] failed to add ICE candidate', err);
          }
        }
      }
    } catch (err) {
      console.error('[VideoCall] signal handling error', err);
    }
  }, [sendSignal, startPeerConnection]);

  const teardown = useCallback(() => {
    resetPeerConnection();
    if (localStreamRef.current) {
      for (const track of localStreamRef.current.getTracks()) track.stop();
    }
    if (screenStreamRef.current) {
      for (const track of screenStreamRef.current.getTracks()) track.stop();
    }
  }, [resetPeerConnection]);

  const handleMessage = useCallback((msg) => {
    switch (msg.type) {
      case 'joined': {
        isHostRef.current = msg.isHost;
        politeRef.current = !msg.isHost;
        setCallStatus(msg.isHost ? 'Waiting for the other participant...' : 'Connected');
        sendProfile();
        break;
      }
      case 'peer-joined': {
        setRemoteLabel('Participant');
        setRemoteInitials('?');
        setCallStatus('Connecting...');
        setShowRemoteTile(true);
        startPeerConnection();
        sendProfile();
        break;
      }
      case 'peer-left': {
        setRemoteLabel('Left the call');
        setCallStatus('Other participant left');
        resetPeerConnection();
        hideRemoteTile();
        break;
      }
      case 'signal': {
        handleSignal(msg.data);
        break;
      }
      case 'profile': {
        const safeName = (msg.data && msg.data.name || 'Participant').toString().trim() || 'Participant';
        setRemoteLabel(safeName);
        setRemoteInitials(initials(safeName));
        break;
      }
      default:
        break;
    }
  }, [handleSignal, hideRemoteTile, resetPeerConnection, sendProfile, startPeerConnection]);

  useEffect(() => {
    if (showRemoteTile && remoteVideoRef.current && remoteStreamRef.current) {
      if (remoteVideoRef.current.srcObject !== remoteStreamRef.current) {
        remoteVideoRef.current.srcObject = remoteStreamRef.current;
      }
    }
  }, [showRemoteTile]);

  // Live call duration ticker for the status bar — purely a display concern,
  // reads from the same callStartTimeRef the "ended" summary already used.
  useEffect(() => {
    if (phase !== 'call') return;
    const id = setInterval(() => {
      if (callStartTimeRef.current) {
        setElapsedLabel(formatDuration(Date.now() - callStartTimeRef.current));
      }
    }, 1000);
    return () => clearInterval(id);
  }, [phase]);

  const connectRef = useRef(null);

  const attemptReconnect = useCallback(async () => {
    if (reconnectAttemptsRef.current >= MAX_RECONNECT_ATTEMPTS) {
      setCallStatus('Call ended');
      teardown();
      return;
    }
    reconnectAttemptsRef.current += 1;
    setCallStatus(`Connection lost. Reconnecting... (${reconnectAttemptsRef.current}/${MAX_RECONNECT_ATTEMPTS})`);
    resetPeerConnection();
    hideRemoteTile();

    try {
      const res = await fetch(`${API_URL}/api/videocalls/${roomId}`);
      if (res.ok) {
        const info = await res.json();
        if (info.ended) {
          setCallStatus('This meeting has ended.');
          teardown();
          return;
        }
        if (info.ticket) {
          activeTicketRef.current = info.ticket;
        }
      }
    } catch (e) {}

    if (reconnectTimerRef.current) clearTimeout(reconnectTimerRef.current);
    reconnectTimerRef.current = setTimeout(
      () => {
        if (connectRef.current) {
          connectRef.current(lastPasswordRef.current);
        }
      },
      Math.min(1000 * reconnectAttemptsRef.current, 5000)
    );
  }, [hideRemoteTile, resetPeerConnection, roomId, teardown]);

  const connect = useCallback((password) => {
    const url = `${WS_BASE}/ws/video-call/${roomId}?ticket=${encodeURIComponent(activeTicketRef.current)}`
      + `&password=${encodeURIComponent(password || '')}&clientId=${encodeURIComponent(clientIdRef.current)}`;
    const ws = new WebSocket(url);
    wsRef.current = ws;

    ws.onopen = () => {
      reconnectAttemptsRef.current = 0;
      setPhaseTracked('call');
      setLocalInitials(initials(displayNameRef.current));

      // Start duration timer
      if (!callStartTimeRef.current) {
        callStartTimeRef.current = Date.now();
      }
    };

    ws.onclose = (event) => {
      if (phaseRef.current !== 'call') {
        setJoinError(describeJoinFailure(event));
        return;
      }
      if (intentionalLeaveRef.current) {
        return; // Handled in confirmLeave
      }
      attemptReconnect();
    };

    ws.onmessage = (event) => handleMessage(JSON.parse(event.data));
  }, [roomId, handleMessage, setPhaseTracked, attemptReconnect]);

  useEffect(() => {
    connectRef.current = connect;
  }, [connect]);

  const handleJoin = () => {
    displayNameRef.current = nameInput.trim() || 'Guest';
    lastPasswordRef.current = passwordInput.trim();
    connect(lastPasswordRef.current);
  };

  const handlePreJoinKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleJoin();
    }
  };

  const toggleMic = async () => {
    if (micTrackRef.current) {
      micTrackRef.current.stop();
      if (localStreamRef.current) localStreamRef.current.removeTrack(micTrackRef.current);
      micTrackRef.current = null;
      setMicOn(false);
      if (audioSenderRef.current) {
        try { await audioSenderRef.current.replaceTrack(null); } catch (e) {}
      }
    } else {
      let stream;
      try {
        stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      } catch (e) {
        return;
      }
      micTrackRef.current = stream.getAudioTracks()[0];
      ensureLocalStream().addTrack(micTrackRef.current);
      if (pcRef.current) {
        if (audioSenderRef.current) {
          try { await audioSenderRef.current.replaceTrack(micTrackRef.current); } catch (e) {}
        } else {
          audioSenderRef.current = pcRef.current.addTrack(micTrackRef.current, localStreamRef.current);
        }
      }
      setMicOn(true);
    }
    refreshLocalTile();
  };

  const toggleCam = async () => {
    if (cameraTrackRef.current) {
      cameraTrackRef.current.stop();
      if (localStreamRef.current) localStreamRef.current.removeTrack(cameraTrackRef.current);
      cameraTrackRef.current = null;
      setCamOn(false);
      if (videoSenderRef.current && !screenStreamRef.current) {
        try { await videoSenderRef.current.replaceTrack(null); } catch (e) {}
      }
    } else {
      let stream;
      try {
        stream = await navigator.mediaDevices.getUserMedia({ video: true });
      } catch (e) {
        return;
      }
      cameraTrackRef.current = stream.getVideoTracks()[0];
      ensureLocalStream().addTrack(cameraTrackRef.current);
      if (pcRef.current && !screenStreamRef.current) {
        if (videoSenderRef.current) {
          try { await videoSenderRef.current.replaceTrack(cameraTrackRef.current); } catch (e) {}
        } else {
          videoSenderRef.current = pcRef.current.addTrack(cameraTrackRef.current, localStreamRef.current);
        }
      }
      setCamOn(true);
    }
    refreshLocalTile();
  };

  const toggleScreen = useCallback(async () => {
    if (screenStreamRef.current) {
      const [track] = screenStreamRef.current.getTracks();
      track.stop();
      if (localStreamRef.current) localStreamRef.current.removeTrack(track);
      screenStreamRef.current = null;
      setScreenOn(false);
      if (videoSenderRef.current) {
        try { await videoSenderRef.current.replaceTrack(cameraTrackRef.current || null); } catch (e) {}
      }
    } else {
      let stream;
      try {
        stream = await navigator.mediaDevices.getDisplayMedia({ video: true });
      } catch (e) {
        return;
      }
      screenStreamRef.current = stream;
      const screenTrack = stream.getVideoTracks()[0];
      ensureLocalStream().addTrack(screenTrack);
      setScreenOn(true);
      if (pcRef.current) {
        if (videoSenderRef.current) {
          try { await videoSenderRef.current.replaceTrack(screenTrack); } catch (e) {}
        } else {
          videoSenderRef.current = pcRef.current.addTrack(screenTrack, localStreamRef.current);
        }
      }
      screenTrack.onended = () => toggleScreen();
    }
    refreshLocalTile();
  }, [ensureLocalStream, refreshLocalTile]);

  // Handle Leave flow with confirmation
  const handleLeaveClick = () => {
    setShowLeaveConfirm(true);
  };

  const confirmLeave = () => {
    setShowLeaveConfirm(false);
    intentionalLeaveRef.current = true;

    // Calculate final duration
    const durationMs = callStartTimeRef.current ? Date.now() - callStartTimeRef.current : 0;
    setFinalDuration(formatDuration(durationMs));

    teardown();
    if (wsRef.current) wsRef.current.close();

    setPhaseTracked('ended');
  };

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setLinkCopied(true);
      setTimeout(() => setLinkCopied(false), 2000);
    } catch (e) {}
  };

  useEffect(() => {
    return () => {
      if (reconnectTimerRef.current) clearTimeout(reconnectTimerRef.current);
      if (wsRef.current) wsRef.current.close();
      teardown();
    };
  }, [teardown]);

  const screenShareSupported = !!(navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia);
  const statusTone = getStatusTone(callStatus);
  const previewInitials = nameInput.trim() ? initials(nameInput) : '?';

  const BrandMark = () => (
    <div className="flex items-center gap-2 mb-6">
      <span className="relative flex h-2.5 w-2.5">
        <span className="absolute inline-flex h-full w-full rounded-full bg-emerald-400 vc-pulse"></span>
      </span>
      <span className="text-[12.5px] font-medium text-[#8a8f9c] tracking-wide">Video call</span>
    </div>
  );

  if (phase === 'loading') {
    return (
      <CenteredCard>
        <BrandMark />
        <h1 className="text-[24px] font-semibold tracking-tight m-0 mb-2">Preparing your meeting</h1>
        <p className="text-[13.5px] text-[#8a8f9c] m-0">This will only take a moment.</p>
        <div className="mt-7 h-[3px] w-full rounded-full bg-[#1c1d24] overflow-hidden">
          <div className="h-full w-1/3 rounded-full bg-emerald-400/80 vc-pulse"></div>
        </div>
      </CenteredCard>
    );
  }

  if (phase === 'error') {
    return (
      <CenteredCard>
        <div className="w-11 h-11 rounded-full bg-red-500/10 border border-red-500/20 flex items-center justify-center text-red-400 mb-5">
          <AlertIcon />
        </div>
        <h1 className="text-[24px] font-semibold tracking-tight m-0 mb-2">Can't join this meeting</h1>
        <p className="text-[#9aa0ab] text-[13.5px] leading-relaxed m-0">{joinError}</p>
        <button
          onClick={() => window.location.reload()}
          className="w-full mt-6 p-3 rounded-xl border border-[#2e303a] bg-white/[0.04] text-[#f1f2f5] font-medium cursor-pointer text-[14px] hover:bg-white/[0.08] transition-colors"
        >
          Try again
        </button>
      </CenteredCard>
    );
  }

  if (phase === 'preJoin') {
    const inputClass = 'w-full px-3.5 py-[12px] rounded-xl border border-[#2e303a] bg-[#0e0f14] text-[#f1f2f5] text-[14px] placeholder:text-[#555965] focus:outline-none focus:border-emerald-400/60 focus:ring-2 focus:ring-emerald-400/20 transition-colors';
    return (
      <PageShell>
        <div className="w-full max-w-[440px] bg-[#121319] border border-[#23252e] rounded-[24px] p-8 md:p-9 shadow-[0_24px_70px_rgba(0,0,0,0.5)] vc-in-scale">
          <BrandMark />

          <div className="flex items-center gap-4 mb-8">
            <div className="relative w-14 h-14 shrink-0 flex items-center justify-center">
              <div className="absolute inset-0 rounded-full border border-emerald-400/40 vc-ring"></div>
              <div className="w-14 h-14 rounded-full bg-[#1a1c24] border border-white/[0.08] flex items-center justify-center text-[18px] font-semibold text-[#e2e3e8]">
                {previewInitials}
              </div>
            </div>
            <div className="min-w-0">
              <h1 className="text-[24px] font-semibold tracking-tight m-0 leading-tight">Ready to join?</h1>
              <p className="text-[13.5px] text-[#8a8f9c] m-0 mt-1">Check your name before you go in.</p>
            </div>
          </div>

          {requiresPassword && (
            <div className="mb-4">
              <label className="block text-[12px] text-[#8a8f9c] mb-1.5 font-medium">Password</label>
              <div className="relative">
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={passwordInput}
                  onChange={(e) => setPasswordInput(e.target.value)}
                  onKeyDown={handlePreJoinKeyDown}
                  placeholder="Meeting password"
                  className={`${inputClass} pr-10`}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword((v) => !v)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-[#6b6f7b] hover:text-[#b0b4bf] transition-colors"
                  tabIndex={-1}
                  title={showPassword ? 'Hide password' : 'Show password'}
                >
                  {showPassword ? <EyeOffIcon /> : <EyeIcon />}
                </button>
              </div>
            </div>
          )}

          <div className="mb-6">
            <label className="block text-[12px] text-[#8a8f9c] mb-1.5 font-medium">Your name</label>
            <input
              autoFocus
              value={nameInput}
              onChange={(e) => setNameInput(e.target.value)}
              onKeyDown={handlePreJoinKeyDown}
              placeholder="Enter your name"
              className={inputClass}
            />
            <p className="text-[11.5px] text-[#6b6f7b] m-0 mt-2">This is how you'll appear until your camera's on.</p>
          </div>

          <button
            className="w-full p-3.5 rounded-xl border-none bg-emerald-400 text-[#062b21] font-semibold cursor-pointer text-[14.5px] hover:bg-emerald-300 active:scale-[0.98] transition-all disabled:opacity-60 disabled:cursor-not-allowed shadow-[0_8px_24px_rgba(52,211,153,0.18)]"
            onClick={handleJoin}
          >
            Join call
          </button>

          {joinError && (
            <p className="text-red-400 text-[13px] mt-3.5 flex items-center gap-1.5">
              <AlertIcon />
              {joinError}
            </p>
          )}
        </div>
      </PageShell>
    );
  }

  if (phase === 'ended') {
    return (
      <CenteredCard maxWidth="420px">
        <div className="text-center">
          <div className="w-16 h-16 bg-red-500/10 rounded-full flex items-center justify-center mx-auto mb-5 border border-red-500/20">
            <XIcon width={32} height={32} className="text-red-500" />
          </div>
          <h1 className="text-[26px] font-semibold tracking-tight text-white mb-2">Meeting ended</h1>
          <p className="text-[#8a8f9c] text-[14.5px] mb-8">
            Total duration: <span className="font-semibold text-white">{finalDuration}</span>
          </p>
          <div className="bg-white/[0.04] border border-[#2e303a] py-3.5 px-4 rounded-xl">
            <p className="text-[#c7cad1] text-[14px] font-medium m-0">Close this tab. Your meeting has ended.</p>
          </div>
        </div>
      </CenteredCard>
    );
  }

  return (
    <div className="flex flex-col min-h-screen text-[#f1f2f5] font-sans box-border relative" style={PAGE_BG}>
      <PageMotionStyles />

      {/* Status bar */}
      <div className="flex items-center justify-between gap-2 px-4 py-2.5 bg-[#0d0e13]/80 backdrop-blur border-b border-[#1c1d24] z-10">
        <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/[0.04] border border-white/[0.06]">
          <span className={`w-2 h-2 rounded-full shrink-0 ${TONE_DOT_CLASS[statusTone]}`}></span>
          <span className="text-[12.5px] text-[#c7cad1] font-medium whitespace-nowrap">{callStatus}</span>
        </div>
        <div className="flex items-center gap-2">
          <span className="hidden sm:inline-flex items-center px-2.5 py-1.5 rounded-full bg-white/[0.03] border border-white/[0.05] text-[11.5px] text-[#767b87] font-medium tabular-nums">
            {elapsedLabel}
          </span>
          <button
            onClick={handleCopyLink}
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white/[0.04] border border-white/[0.06] text-[12px] font-medium text-[#c7cad1] hover:bg-white/[0.08] transition-colors shrink-0"
            title="Copy invite link"
          >
            {linkCopied ? <CheckIcon /> : <LinkIcon />}
            <span className="hidden sm:inline">{linkCopied ? 'Copied' : 'Copy link'}</span>
          </button>
        </div>
      </div>

      {/* Video Area */}
      <div className={isFocused ? "flex-1 relative overflow-hidden" : "flex-1 grid grid-cols-[repeat(auto-fit,minmax(280px,1fr))] gap-4 p-4 content-center"}>

        {/* Local Video Tile */}
        <div className={isFocused
          ? "absolute top-4 right-4 w-32 md:w-56 aspect-video rounded-2xl overflow-hidden shadow-[0_12px_32px_rgba(0,0,0,0.5)] border border-white/[0.08] z-20 bg-[#111219] transition-all duration-300 ease-out"
          : "relative bg-[#111219] rounded-2xl overflow-hidden aspect-video border border-[#1f2028] vc-in"}>
          <video
            ref={localVideoRef}
            autoPlay
            playsInline
            muted
            className={`w-full h-full object-cover bg-[#111219] ${!hasLocalVideo ? 'opacity-0' : ''}`}
          />
          {!hasLocalVideo && (
            <div className="absolute inset-0 flex items-center justify-center bg-[radial-gradient(circle_at_center,_#1b1c25_0%,_#101118_75%)] z-0">
              <div className="w-16 h-16 rounded-full bg-white/[0.06] border border-white/[0.08] flex items-center justify-center text-[20px] font-semibold text-[#e2e3e8]">
                {localInitials}
              </div>
            </div>
          )}
          <div className="absolute bottom-2.5 left-2.5 flex items-center gap-1.5 bg-black/55 backdrop-blur-sm px-2.5 py-1 rounded-full text-[11.5px] z-10 font-medium">
            {!micOn && <span className="text-red-400"><MicOffIcon width={12} height={12} /></span>}
            You
          </div>
        </div>

        {/* Remote Video Tile */}
        {showRemoteTile && (
          <div
            onClick={() => !isFocused && setHasRemoteVideo(hasRemoteVideo => { setIsFocused(hasRemoteVideo); return hasRemoteVideo; })}
            className={isFocused
              ? "absolute inset-0 w-full h-full bg-[#08090d] z-0"
              : "relative bg-[#111219] rounded-2xl overflow-hidden aspect-video border border-[#1f2028] cursor-pointer hover:border-emerald-400/30 transition-colors vc-in"}
          >
            <video
              ref={remoteVideoRef}
              autoPlay
              playsInline
              className={`w-full h-full bg-[#111219] ${isFocused ? 'object-contain' : 'object-cover'} ${!hasRemoteVideo ? 'opacity-0' : ''}`}
            />
            {!hasRemoteVideo && (
              <div className="absolute inset-0 flex items-center justify-center bg-[radial-gradient(circle_at_center,_#1b1c25_0%,_#101118_75%)] z-0">
                <div className="w-16 h-16 rounded-full bg-white/[0.06] border border-white/[0.08] flex items-center justify-center text-[20px] font-semibold text-[#e2e3e8]">
                  {remoteInitials}
                </div>
              </div>
            )}

            <div className={`absolute bottom-2.5 left-2.5 bg-black/55 backdrop-blur-sm px-2.5 py-1 rounded-full text-[11.5px] z-10 font-medium ${isFocused ? 'md:bottom-6 md:left-6 md:text-[13px]' : ''}`}>
              {remoteLabel}
            </div>

            {/* Close Focused View Button */}
            {isFocused && (
              <button
                onClick={(e) => { e.stopPropagation(); setIsFocused(false); }}
                className="absolute top-6 left-6 z-30 p-2.5 bg-black/40 hover:bg-black/70 rounded-full text-white transition-colors border border-white/10"
                title="Back to grid view"
              >
                <XIcon />
              </button>
            )}
          </div>
        )}
      </div>

      {/* Control Bar */}
      <div className="flex justify-center p-4 md:p-6 bg-gradient-to-t from-[#08090d] via-[#08090d]/95 to-transparent z-10" style={{ paddingBottom: 'max(1.25rem, env(safe-area-inset-bottom, 1.25rem))' }}>
        <div className="flex items-center gap-3 md:gap-4 px-3 py-2.5 rounded-[28px] bg-[#121319]/90 backdrop-blur border border-[#23252e] shadow-[0_16px_40px_rgba(0,0,0,0.45)]">
          <ControlButton
            icon={micOn ? <MicOnIcon /> : <MicOffIcon />}
            isOn={micOn}
            label="Mic"
            onClick={toggleMic}
            title={micOn ? 'Mute microphone' : 'Unmute microphone'}
          />
          <ControlButton
            icon={camOn ? <CamOnIcon /> : <CamOffIcon />}
            isOn={camOn}
            label="Camera"
            onClick={toggleCam}
            title={camOn ? 'Turn off camera' : 'Turn on camera'}
          />
          <ControlButton
            icon={<ScreenIcon />}
            isOn={screenOn}
            label="Screen"
            onClick={toggleScreen}
            disabled={!screenShareSupported}
            title={screenShareSupported ? (screenOn ? 'Stop sharing' : 'Share your screen') : 'Screen sharing is not supported on this device/browser'}
          />
          <div className="w-px h-9 bg-[#23252e]"></div>
          <button onClick={handleLeaveClick} title="Leave call" className="flex flex-col items-center gap-1.5">
            <span className="w-14 h-14 rounded-full bg-red-600 hover:bg-red-500 flex items-center justify-center transition-all duration-150 active:scale-90 text-white">
              <XIcon />
            </span>
            <span className="text-[11px] text-[#c7cad1] font-medium">Leave</span>
          </button>
        </div>
      </div>

      {/* Leave Confirmation Modal */}
      {showLeaveConfirm && (
        <div className="fixed inset-0 bg-black/65 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-[#121319] border border-[#23252e] rounded-2xl p-6 max-w-sm w-full shadow-[0_24px_70px_rgba(0,0,0,0.5)] vc-in-scale">
            <div className="w-10 h-10 rounded-full bg-red-500/10 border border-red-500/20 flex items-center justify-center text-red-400 mb-4">
              <XIcon width={18} height={18} />
            </div>
            <h3 className="text-[17px] font-semibold text-white mb-1.5">Leave meeting?</h3>
            <p className="text-[#8a8f9c] text-[13.5px] mb-6">You can rejoin with the same link if you change your mind.</p>
            <div className="flex justify-end gap-2.5">
              <button
                onClick={() => setShowLeaveConfirm(false)}
                className="px-4 py-2 rounded-xl text-[13.5px] font-medium bg-white/[0.04] text-[#c7cad1] hover:bg-white/[0.08] transition-colors border border-[#2e303a]"
              >
                Cancel
              </button>
              <button
                onClick={confirmLeave}
                className="px-4 py-2 rounded-xl text-[13.5px] font-medium bg-red-600 text-white hover:bg-red-500 transition-colors"
              >
                Leave
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}